import { OtInboundActionType, StatusSnackbar } from "../reducers/otInboundReducer";

export const setEnablePriority = (): OtInboundActionType =>  ({type: 'enablePriority'});
export const setDisabledPriority = (): OtInboundActionType =>  ({type: 'disabledPriority'});

export const setShowSnackbar =
 (
    open: boolean,
    message: string,
    status: StatusSnackbar
 ): OtInboundActionType => {
     return {
         type: 'setSnackbar',
         payload: {open, message, status}
     }
 } 